/** P32 (Feb 27, 2026) — Preview-before-saving dialog. */
import React from 'react';
import { formatDateMDY } from '../utils/dates';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

function PreviewClaimDialog({ open, onClose, payload, totals, onConfirm, submitting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl" data-testid="preview-claim-dialog">
        <DialogHeader>
          <DialogTitle>Preview claim before saving</DialogTitle>
          <DialogDescription>Review the details below. Nothing is saved until you click Confirm &amp; Submit.</DialogDescription>
        </DialogHeader>
        {payload ? (
          <div className="space-y-3 text-sm">
            <div className="grid grid-cols-2 gap-3">
              <div><strong>Patient:</strong> {payload._patientName}</div>
              <div><strong>Payer:</strong> {payload.payer_type} · {payload.payer_program || '—'}</div>
              <div><strong>Service:</strong> {payload.service_code}</div>
              <div><strong>Dx:</strong> {payload.diagnosis_code || '—'}</div>
              <div><strong>Place of service:</strong> {payload.place_of_service}</div>
              <div><strong>Visits:</strong> {payload.service_lines.length}</div>
            </div>
            <div className="border-t pt-3">
              <strong>Service lines:</strong>
              <table className="w-full text-xs mt-2" data-testid="preview-lines-table">
                <thead className="text-slate-500">
                  <tr><th className="text-left">#</th><th className="text-left">Date</th><th className="text-left">Units</th><th className="text-left">Modifier</th></tr>
                </thead>
                <tbody>
                  {payload.service_lines.map((sl, i) => (
                    <tr key={`${sl.service_date || 'na'}-${sl.units || 0}-${i}`}>
                      <td>{i + 1}</td>
                      <td>{formatDateMDY(sl.service_date)}</td>
                      <td>{sl.units}</td>
                      <td className="font-mono">{sl.modifier_1 || <span className="italic text-slate-400">none</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="border-t pt-3 grid grid-cols-2 gap-3">
              <div><strong>Total charge:</strong> ${totals.totalCharge.toFixed(2)}</div>
              <div><strong>Patient responsibility:</strong> ${Number(payload.patient_responsibility || 0).toFixed(2)}</div>
              <div className="col-span-2 text-indigo-900 font-semibold"><strong>Net payout:</strong> ${(totals.totalCharge - Number(payload.patient_responsibility || 0)).toFixed(2)}</div>
            </div>
          </div>
        ) : null}
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={onClose} data-testid="preview-cancel-btn">Back to edit</Button>
          <Button onClick={onConfirm} disabled={submitting} className="bg-indigo-900 hover:bg-indigo-800" data-testid="preview-confirm-submit-btn">
            {submitting ? '…' : 'Confirm & Submit'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default PreviewClaimDialog;
